import { useState, useEffect } from "react";
import {
  Box,
  InputBase,
  Button,
  Dialog,
  DialogContent,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseB2BOrders } from "./UseB2BOrders";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import FilterSearch from "./FilterSearch";
import { useSnackbar } from "notistack";
import B2BOffers from "./offer/B2BOffers";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

export default function B2BOrders() {
  const { enqueueSnackbar } = useSnackbar();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const {
    getSMSTemplate,
    sendSMS,
    getOrderList,
    updateOrder,
    assignOffer,
    confirmOrder,
  } = UseB2BOrders();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("TotalCost", "Desc");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [expanded, setExpanded] = useState(
    location.state && location.state.panel ? location.state.panel : "orders"
  );
  const [SMSTemplate, setSMSTemplate] = useState();
  const [orderRes, setOrderRes] = useState();
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const { toSolar } = require("jdate-convert");

  const today = toSolar(new Date().toJSON().slice(0, 10));

  const [state, setState] = useState({
    year: today ? Number(today.slice(0, 4)) : 1403,
    month: today ? Number(today.slice(5, 7)) : "",
  });
  const [SMSState, setSMSState] = useState({
    year: undefined,
    month: undefined,
    type: undefined,
    allUser: "",
  });

  useEffect(() => {
    if (location.state && location.state.state) {
      setState(location.state.state);
    }
  }, [location.state]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getSMSTemplate((SMSTemp) => {
      setSMSTemplate(SMSTemp);
    });
    getOrderList(
      state,
      myPc,
      search,
      (orders) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(orders.totalPage);
          return;
        }
        setOrderRes(orders);
      },
      true
    );
  }, [myPc, state]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return setOpen(true);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("orders");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "mobile",
      headerName: " موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "fullName",
      headerName: "نام",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },

    {
      field: "orgenizeName",
      headerName: "نام سازمان",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.orgenizeName}
          </Typography>
        );
      },
    },
    {
      field: "totalCost",
      headerName: "مجموع خرید",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.totalCost ? toMoney(cellValues.row.totalCost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "offerPercent",
      headerName: "درصد کمیسیون",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.offerPercent ? cellValues.row.offerPercent : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalOffer",
      headerName: "کمیسیون",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.totalOffer ? toMoney(cellValues.row.totalOffer) : 0}
          </Typography>
        );
      },
    },
    {
      field: "walletDate",
      headerName: "تسویه",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.walletDate ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [{ name: msActiveMenu.pageTitle, url: "/b2bcustomers" }],
      }}
    >
      <Accordion
        id="orders"
        expanded={expanded === "orders"}
        onChange={handleChange("orders")}
        style={{ backgroundColor: "#e1e1e11c" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FiberManualRecordIcon color="secondary" fontSize="small" />
            <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
              سفارشات B2B
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails
          sx={{ display: "flex", flexDirection: "column", pt: 0 }}
        >
          <Box
            sx={{
              mb: 1,
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <FilterSearch setState={setState} state={state} />
          </Box>
          <Box sx={{ height: "30rem" }}>
            {orderRes ? (
              <DataGrid
                className="ltr-grid"
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                pageSize={orderRes.pageCondition.pageCount}
                rows={orderRes && orderRes.items ? orderRes.items : []}
                paginationMode="server"
                page={orderRes.pageCondition.page - 1}
                onPageChange={(page) => {
                  updatePage(page + 1);
                }}
                rowCount={
                  orderRes?.pageCondition.totalItemCount
                    ? orderRes.pageCondition.totalItemCount
                    : 1
                }
                enableRangeSelection={true}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    scrollTo: myPc.scrollTo,
                    newFunc: newFunc,
                    isLtr: true,
                    rowCount: orderRes?.pageCondition.totalItemCount
                      ? orderRes.pageCondition.totalItemCount
                      : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: deCapitalizeFirstLetter(myPc.sortColumn),
                        sort: deCapitalizeFirstLetter(myPc.sortOrder),
                      },
                    ],
                  },
                  pagination: {
                    page: myPc.page,
                  },
                }}
                onSortModelChange={(model) => {
                  updateSort(
                    model[0].field,
                    model[0].sort == "asc" ? "asc" : "desc"
                  );
                }}
                sortingOrder={["desc", "asc"]}
                sortingMode="server"
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 2 }}>
            <Button
              sx={{ width: "90px" }}
              color="secondary"
              variant="contained"
              onClick={() => {
                setCheckState({
                  name: "آپدیت سفارشات",
                  show: true,
                  value: "update",
                });
              }}
            >
              ایجاد
            </Button>
            <Button
              sx={{ width: "90px" }}
              color="info"
              variant="contained"
              onClick={() => {
                setCheckState({
                  name: "آپدیت آفر سفارشات",
                  show: true,
                  value: "assign",
                });
              }}
            >
              آفر
            </Button>
            <Button
              sx={{ width: "90px" }}
              variant="contained"
              onClick={() => {
                setCheckState({
                  name: "آپدیت پرداخت سفارشات",
                  show: true,
                  value: "confirm",
                });
              }}
            >
              پرداخت
            </Button>
            <Button
              sx={{ width: "90px" }}
              color="warning"
              variant="contained"
              onClick={() => {
                setSMSState({
                  type: undefined,
                  year: state.year,
                  month: state.month,
                  allUser: "",
                });
                setOpen(true);
              }}
            >
              اطلاع رسانی
            </Button>
          </Box>
        </AccordionDetails>
      </Accordion>
      <B2BOffers
        expanded={expanded}
        setExpanded={setExpanded}
        search={search}
        state={state}
      ></B2BOffers>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          if (checkState.value == "assign") {
            assignOffer(state, () => {
              refresh();
            });
            return;
          }
          if (checkState.value == "confirm") {
            confirmOrder(state, () => {
              refresh();
            });
            return;
          }
          if (checkState.value == "update") {
            updateOrder(state, () => {
              refresh();
            });
            return;
          }
          if (checkState.value == "SMS") {
            sendSMS(SMSState, () => {
              refresh();

              setOpen(false);
            });

            return;
          }
        }}
      />
      <Dialog
        open={open}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiPaper-root ": {
            height: "30",
          },
        }}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              // alignItems: "center",
              gap: 2,
            }}
          >
            <Autocomplete
              size="small"
              value={SMSState.type ? SMSState.type : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setSMSState({ ...SMSState, type: newValue });
                } else {
                  setSMSState({ ...SMSState, type: undefined });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return SMSTemplate?.find((m) => m.id == option).title;
                }
                return "";
              }}
              fullWidth
              options={SMSTemplate?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="نوع SMS" />
              )}
            />
            <FormControl
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 2,
              }}
            >
              <RadioGroup
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={SMSState.allUser}
                onChange={(event) => {
                  setSMSState({
                    ...SMSState,
                    allUser: JSON.parse(event.target.value),
                  });
                }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="تمامی کاربران"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="کاربران جدید"
                />
              </RadioGroup>
            </FormControl>
            <Button
              sx={{ width: "100px", mx: "auto" }}
              variant="contained"
              onClick={() => {
                if (SMSState.allUser == undefined || !SMSState.type) {
                  enqueueSnackbar(
                    "لطفا اطلاعات اطلاع رسانی را کامل انتخاب کنید",
                    {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    }
                  );
                  return;
                }
                setCheckState({
                  name: "اطلاع رسانی ",
                  show: true,
                  value: "SMS",
                });
              }}
            >
              ایجاد
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Detail>
  );
}
